<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Categoria
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: 80px;width: auto;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Bancos
    v-flex(xs12)
      template
        v-dialog(v-model='dialog', persistent max-width='700px')
              v-btn.mb-2(v-if="cre" slot='activator', style="border-radius:5px;background-color:#0093dd;") Nuevo Banco
              v-container(style='background-color:white !important;max-width: 700px;')
                v-card-title.justify-center
                    span.headline Banco
                div(style="margin-top: 20px;")
                    v-flex(xs12 sm12)
                        v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                            v-flex(xs8)
                              v-form(enctype="multipart/form-data")
                              
                                v-select(outline
                                :items="options"
                                v-model="form.categoria"
                                prepend-inner-icon="chevron_right",
                                label="Seleccione la categoría de la cuenta:")
                                
                                v-text-field(v-if='form.categoria === "Nacional" || form.categoria === "Internacional" || form.categoria === "Zelle"'
                                outline
                                v-model="form.nombre"
                                prepend-inner-icon="description"
                                label="Nombre y Apellido:")

                                v-text-field(v-if='form.categoria === "Nacional"'
                                outline
                                v-model="form.identificacion"
                                prepend-inner-icon="description"
                                label="Identificación:")

                                v-text-field(v-if='form.categoria === "Nacional" || form.categoria === "Internacional"'
                                outline
                                v-model="form.banco"
                                prepend-inner-icon="description"
                                label="Nombre del banco:")
                                
                                v-text-field(v-if='form.categoria === "Nacional" || form.categoria === "Internacional"'
                                outline
                                v-model="form.cuenta"
                                prepend-inner-icon="description"
                                label="Número de cuenta:")

                                v-text-field(v-if='form.categoria === "Nacional" || form.categoria === "Internacional"'
                                outline
                                v-model="form.tipo"
                                prepend-inner-icon="description"
                                label="Tipo de cuenta:")

                                v-text-field(v-if='form.categoria === "Nacional" || form.categoria === "Internacional" || form.categoria === "Zelle"'
                                outline
                                v-model="form.correo"
                                prepend-inner-icon="description"
                                label="Correo electrónico:")


                            v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-progress-circular(indeterminate='', color='primary')
                            v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-center='', justify-center='', row='', wrap fill-height='')
                                    v-btn(style="background:#0093dd;border-radius:10px;", @click.native='save') Guardar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir

        div(style="margin-top:20px")
          v-flex(xs12)
            v-layout(wrap)
              v-flex(xs12)
                v-text-field(v-model='search2', append-icon='search', label='Buscar' style='width:100%;')
        v-layout(align-start='', justify-start='', row='', fill-height='')
          v-flex(xs12 style='margin-top: 5px;')
            v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
                v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                    span.white--text Lista de Bancos
            v-data-table.elevation-1(:headers='headers', :items="bancos", :search='search2', style="margin-top: 5px;")
              template(slot='items', slot-scope='props')
                td(v-if='props.item.correo') {{ props.item.correo }}
                td(v-else) N/A
                td(v-if='props.item.categoria') {{ props.item.categoria }}
                td(v-else) N/A
                td(v-if='props.item.banco') {{ props.item.banco }}
                td(v-else) N/A
                td(v-if='props.item.nombre') {{ props.item.nombre }}
                td(v-else) N/A
                td.justify-start.layout.px-0
                    v-btn.mx-0(v-if="mod" icon, @click='editItem(props.item)', style='margin-top: -8px;')
                        v-icon(color='teal') edit
                    v-btn.mx-0(v-if="elm" icon, @click='deleteItem(props.item)', style='margin-top: -8px;')
                        v-icon(color='pink') delete
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "mAyuda",
  components: {},
  data: () => ({
    search2: "",
    loading: false,
    form: {
      nombre: "",
      identificacion: "",
      tipo: "",
      cuenta: "",
      banco: "",
      categoria: "",
      correo: ""
    },
    options: ["Nacional", "Internacional", "Zelle"],
    bancos: [],
    dialog: false,
    ruta: server + ":" + port,
    headers: [
      { text: "Correo", value: "correo" },
      { text: "Categoría", value: "categoria" },
      { text: "Banco", value: "banco" },
      { text: "Nombre", value: "nombre" },
      { text: "Acciones" }
    ],
    editedIndex: -1,
    defaultForm: {
      nombre: "",
      identificacion: "",
      tipo: "",
      cuenta: "",
      banco: "",
      categoria: "",
      correo: ""
    },
    cre: "",
    mod: "",
    elm: ""
  }),
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.webamairca.permisos.length; i++) {
        if (this.$store.state.webamairca.permisos[i].ruta === "Bancos") {
          for (
            let j = 0;
            j < this.$store.state.webamairca.permisos[i].accion.length;
            j++
          ) {
            if (this.$store.state.webamairca.permisos[i].accion[j] === "Crear") {
              this.cre = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] === "Modificar") {
              this.mod = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    initialize() {
      this.editedIndex = -1;
      Api.get("bancos").then(res => {
        this.bancos = res.data;
      });
    },
    editItem(item) {
      this.editedIndex = this.bancos.indexOf(item);
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog = true;
    },
    deleteItem(item) {
      this.$swal
        .fire({
          title: "¿Estás seguro?",
          text: "No podrás revertir esta operación!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si, Eliminar!"
        })
        .then(result => {
          if (result.value) {
            Api.delete("bancos/" + item._id)
              .then(res => {
                this.$swal.fire(
                  "Felicidades.!",
                  "Eliminación realizada exitosamente.",
                  "success"
                );
                this.initialize();
              })
              .catch(err => {
                console.error(err);
              });
          }
        });
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
      this.initialize();
    },
    save() {
      this.loading = true;
      if (this.editedIndex > -1) {
        Api.put("bancos", this.form)
          .then(res => {
            this.form = Object.assign({}, this.defaultForm);
            this.dialog = false;
            this.$swal.fire(
              "Felicidades.!",
              "Modificación realizada exitosamente.",
              "success"
            );
            this.close();
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
            this.$message.error("A ocurrido un error." + err);
          });
      } else {
        Api.post("bancos", this.form)
          .then(res => {
            this.form = Object.assign({}, this.defaultForm);
            this.dialog = false;
            this.$swal.fire(
              "Felicidades.!",
              "Registro realizado exitosamente.",
              "success"
            );
            this.close();
            this.loading = false;
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            this.$message.error("A ocurrido un error." + err);
          });
      }
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/scss/categoria.scss";
</style>
